import {
  MILEAGETRANSECTION_ALL,
  MILEAGETRANSECTION_GET,
  MILEAGETRANSECTION_POST,
  MILEAGETRANSECTION_PUT,
  MILEAGETRANSECTION_DELETE,
  MILEAGETRANSECTION_LOADING,
  MILEAGETRANSECTION_ERROR,
} from '../../actions/types';

const initialState = {
  trailerTail: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names, default-param-last
export default function (state = initialState, action) {
  switch (action.type) {
    case MILEAGETRANSECTION_LOADING:
      return { isLoading: true, isCompleted: true };
    case MILEAGETRANSECTION_ERROR:
      return { isLoading: false, isCompleted: false };
    case MILEAGETRANSECTION_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case MILEAGETRANSECTION_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case MILEAGETRANSECTION_POST:
      return { isLoading: false, isCompleted: true };
    case MILEAGETRANSECTION_PUT:
      return { isLoading: false, isCompleted: true };
    case MILEAGETRANSECTION_DELETE:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
